/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo, useState, useEffect } from "react";
import { Box, Typography, FormGroup, TextField, FormControl, Button, } from "@mui/material";
import { styled } from '@mui/material/styles';
import { ThemeProvider } from "@mui/material/styles";
import en from "../../nls/en.json";
import { OptionsWrapper } from "../Styles/AcademicSubjectsStyle";
import { theme } from "../Styles/BasicInfo";
import { isEmpty } from "../../utils/constants";
import { useSelector } from "react-redux";
import { isValidUrl } from "../../utils/validation";
import Style from "../Styles/CssModulesGlobal.module.scss";
import MentorImg3 from "../assests/images/user-avatar.svg";
import CustomToolTip from "../common/CustomToolTip/CustomToolTip";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import MyAvailability from "../Meetings/Calendly/MyAvailability";

const cssObject = {
  display: "inline-flex",
  alignItems: "center",
  marginRight: "10px",
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const MeetingRequirements = ({
  step,
  getLinks = false,
  setProfilePic = false,
  toggleDialog,
  myRef
}) => {
  const { savedAnswer } = useSelector(
    ({ studentInfoSlice }) => studentInfoSlice
  );
  const { BASIC_INFORMATION } = savedAnswer;

  const [calendly_link, setCalendlyLink] = useState(
    BASIC_INFORMATION?.calendly_link
  );
  const [calendly_token, setCalendlyToken] = useState(
    BASIC_INFORMATION?.calendly_token
  );

  const isCalendlyLinkValid = useMemo(
    () => isValidUrl(calendly_link),
    [calendly_link]
  );

  const [fileError, setFileError] = useState("");
  const [previewPic, setPreviewPic] = useState(BASIC_INFORMATION?.profile_page_link);
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { value } = e.target;
    setCalendlyToken(value);
    let error = {};
    if (isEmpty(value)) {
      error.calendly_token = "Calendly token is required";
    }
    setFormErrors(error);
  }
  const handleChangeLink = (e) => {
    const { value } = e.target;
    setCalendlyLink(value);
    let error = {};
    if (isEmpty(value)) {
      error.calendly_token = "Calendly Link is required";
    }
    if(!isEmpty(value)) {
      isValidUrl(calendly_link)
    }
    setFormErrors(error);
  }
  
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile?.name?.split('.')?.pop()?.toLowerCase();
      if (['jpg', 'png', 'jpeg']?.includes(fileExtension)) {
        setProfilePic(selectedFile);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewPic(reader.result);
        };
        reader.readAsDataURL(selectedFile);
      } else {
        toggleDialog()
        e.target.value = null;
      }
    }
  };

  useMemo(() => {
    getLinks ? getLinks({ calendly_link, calendly_token }) : "";
  }, [calendly_link, calendly_token]);

  useEffect(()=>{
    if(myRef){
      myRef.current.scrollTop = 0;
    }
  },[]);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box variant="form">
          <Typography variant="h3">{en.ALMOST_DONE}</Typography>
          <OptionsWrapper>
            {step === 3 && (
              <>
                <Typography sx={{ mt: 8 }}> {en.ADD_AVAILABILITY} <span style={{color: "#DC3545" }}>*</span></Typography>
                <FormGroup sx={{ mt: 2 }}>
                  <FormControl variant="filled">
                    <MyAvailability></MyAvailability>
                  </FormControl>
                </FormGroup>
              </>
            )}
            {step === 4 && (
              <>
                <FormGroup sx={{ mt: 8 }}>
                  <Typography> {en.PROFILE_PIC_SUBTEXT} <span style={{color: "#DC3545" }}>*</span></Typography>
                  <diV
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "5%",
                    }}
                  >
                    <Box className={Style.mentorImage}>
                      {previewPic ? (
                        <img src={previewPic} />
                      ) : (
                        <img src={MentorImg3} />
                      )}
                    </Box>
                  </diV>
                  <Box sx={{display:"flex",justifyContent:"center",width:1,my:3}}>
                  <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    tabIndex={-1}
                    startIcon={<FileUploadOutlinedIcon />}
                    onChange={handleFileChange}
                  >
                    Upload profile picture
                    <VisuallyHiddenInput type="file" />
                  </Button>
                  </Box>
                  {/* <TextField
                    name="profile"
                    type="file"
                    variant="filled"
                    value=""
                    label="Profile Picture"
                    required
                    inputProps={{
                      accept: "image/jpeg, image/png, image/gif",
                    }}
                    onChange={handleFileChange}
                  /> */}
                  {fileError && (
                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                      {fileError}
                    </Typography>
                  )}

                {/* GUIDLINES FOR PROFILE UPLOAD */}
                <Typography variant="body2" sx={{ mt: 2 }}>
                Please upload your profile picture. Follow these guidelines:
                <ul>
                    <li>no hats/sunglasses</li>
                    <li>no blurry photos</li>
                    <li>no distracting backgrounds</li>
                    <li>you should look professional/approachable (smile!)</li>
                    <li>no dark/super bright lighting</li>
                    <li>no selfies</li>
                    <br/>
                </ul>
          </Typography>
</FormGroup>
              </>
            )}
          </OptionsWrapper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MeetingRequirements;
